export default theme => ({
  marginTop: {
    marginTop: theme.spacing(2)
  },
  rolesDatagrid: {
    marginTop: theme.spacing(3)
  },
  usersContainer: {
    marginTop: theme.spacing(2),
    minHeight: 52,
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiAutocomplete-root': {
      flex: 1
    }
  },
  roleUsers: {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 'normal',
    height: 24,
    '&.popper': {
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& > div:not(:last-child)': {
        marginBottom: theme.spacing(1)
      }
    }
  },
  selectAllButton: {
    marginLeft: theme.spacing(1)
  }
});
